import { Outlet, useLocation } from "react-router-dom";
import Header from "components/layouts/Header";
import Footer from "components/templates/signUp/Footer";

const signUpPages = ["/beta/signup", "/signup"];

const Layout = () => {
  const location = useLocation();

  // 회원가입 반응형 페이지 조건문
  const isSignUpPage = signUpPages.includes(
    location.pathname.toLocaleLowerCase()
  );
  const layoutClassName = isSignUpPage
    ? "w-full"
    : "w-full h-full min-w-[1380px]";

  return (
    <div className={layoutClassName}>
      <Header />
      <Outlet />
      {isSignUpPage && <Footer />}
    </div>
  );
};

export default Layout;
